export function byId<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

export function inputById(id: string): HTMLInputElement | null {
  return byId<HTMLInputElement>(id);
}

export function inputValue(id: string): string {
  return inputById(id)?.value ?? '';
}

/** Escapes user-provided text before injecting it into innerHTML templates. */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
